export default "__VITE_ASSET__374745f7__"